import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Partner } from '../../models/partner';
import { PartnerStateService } from '../../services/partner-state.service';
import { PartnerStateEnum } from '../../services/partner-state.enum';
import { MessageComponent } from '../../../general/components/message/message.component';

@Component({
  selector: 'app-edit-child',
  templateUrl: './edit-child.component.html',
  styleUrls: ['./edit-child.component.css']
})
export class EditChildComponent implements OnInit, OnChanges {

  partner: Partner;

  actionInProgress: boolean;

  private _partnerFormIsValid: boolean;

  constructor(
    private partnerStateService: PartnerStateService,
    private dialog: MatDialog,
  ) {
  }

  get isSaveButtonEnabled(): boolean {
    return this._partnerFormIsValid && !this.actionInProgress;
  }

  get childName(): string {
    if (this.partner) {
      return this.partner.name;
    }

    return '';
  }

  ngOnInit() {
    this.partner = this.partnerStateService.selectedChild.clone;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.partner = this.partnerStateService.selectedChild;
  }

  cancelClick() {
    this.partnerStateService.update(PartnerStateEnum.ShowChildrenList);
  }

  deleteClick() {
    const dialogRef = this.dialog.open(MessageComponent, {
      data: {
        message: 'Remove child question' ,
        noCaption: 'Abort',
        yesCaption: 'Confirm'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.actionInProgress = true;
        this.partnerStateService.removeChild(this.partner).subscribe(result2 => {
          if (result2) {
            this.partnerStateService.update(PartnerStateEnum.ShowChildrenList);
          }
          this.actionInProgress = false;
        });
      }
    });
  }

  saveClick() {
    this.actionInProgress = true;
    this.partnerStateService.updateChild(this.partner).subscribe(result => {
      if (result) {
        this.partnerStateService.update(PartnerStateEnum.ShowChildrenList);
      }
      this.actionInProgress = false;
    });
  }

  onChildFormInvalid() {
    this._partnerFormIsValid = false;
  }

  onChildFormValid() {
    this._partnerFormIsValid = true;
  }
}
